import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

import { ref, watch } from "vue";

// PC端路由
const routesPc =  [
    {
       path:'/',
      name: 'Home',
      component: () => import('@/views/pcindextw.vue'),
    },
    {
      path:'/game',
     name: 'game',
     component: () => import('@/views/pcindextw2.vue'),
   },

  
 

]


// 移动端路由表
const routesMB = [
  {
    path:'/',
   name: 'Home',
   component: () => import('@/views/mindextw.vue'),
 },
 {
  path:'/game',
 name: 'game',
 component: () => import('@/views/mindextw2.vue'),
},

 
]

// 声明变量用来接routers
var routes = [];
const screenWidth = ref()
// 获取页面宽度
screenWidth.value = document.body.clientWidth
if (screenWidth.value <= 1200) {
    console.log('is Mobile');

    routes = routesMB
} else {
    console.log('pc')
    routes = routesPc
}
window.onresize = () => {
    screenWidth.value = document.body.clientWidth;
};
// 监听页面宽度
watch(screenWidth, (newVal, oldVal) => {
    let timer = setTimeout(() => {
        if (newVal <= 1200) {
            // 小于758就是移动端 就把移动端路由表赋给routes
            console.log('is Mobile');
            routes = routesMB
            window.location.reload()
        } else {
            console.log('pc')
            // 大于就是pc端，把pc端路由表赋给routes
            routes = routesPc
            window.location.reload()
        }
        // 重绘页面
    }, 500)
    return () => {
        // 清除定时器
        clearTimeout(timer)
    }
}, {
    // 深度清除
    deep: true,
})
 
 
 
const router = createRouter({
    history: createWebHistory(),
    routes,
   
})


router.beforeEach((to, from, next) => {
    document.title = (to?.meta?.title) || document.title;
    next();
  })
  

export default router
